import React from "react";
import {useRef, useEffect, useState} from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faUpload } from '@fortawesome/free-solid-svg-icons';
// import './remoteCtrlStyle.css';

// User Defined Modules
import AlertBox from './alertBox/alertBox';
import GetScreenSize from '../../utils/getscreensize';
import CommandsPanel from "../controlPanel/commandsPanel/commandsPanel";
import RemoteSideBar from "../../component/remoteSideBar/remoteSideBar";
import LoaderSquare from "../../component/loaderSquare/loaderSquare";
import OutputBox from '../../component/outputComponent/outputComp';

function RemoteCtrlPage () {
    const [data, setData] = useState(null);
    const [url, setUrl] = useState(null); 
    const [width, setWidth] = useState(null);
    const [height, setHeight] = useState(null);
    // const [alert, setAlert] = useState(null);

    useEffect(() => {
        const getCookie = (name) => {
            const match = document.cookie
              .split("; ")
              .find((row) => row.startsWith(name + "="));
          
            if (!match) return null; // Return null if cookie not found
      
            try {
              const rawValue = match.split("=")[1];
            //   console.log(`Raw cookie value for ${name}:`, rawValue);
              return decodeURIComponent(rawValue); // Properly decode it
            } catch (error) {
              console.error(`Error decoding cookie ${name}:`, error);
              return null; // Return null if decoding fails
            }
        }

        const grabDevice = async () => {
            const loginToken = getCookie('data');
            const deviceId = window.location.pathname.split("/")[3];

            // Fetches the single devices data
            try {
                const fetchDevice = await axios({
                    url: `${import.meta.env.VITE_DEVBACKENDPATH}:${import.meta.env.VITE_BACKENDPORT}/api/devicedata/fetchone`,
                    method: "POST",
                    data: {
                        loginToken: loginToken,
                        deviceId: deviceId
                    }
                });

                // If device data was successfully fetched set the Data and Url states
                if(fetchDevice.status === 200) {
                    setTimeout(async() => {
                        setData(fetchDevice.data.device);
                        setUrl(`https://${fetchDevice.data.device.domainName}:${fetchDevice.data.device.portRemote}/?apikey=${fetchDevice.data.device.apiKey}`);
                        console.log("Grabbed device data from DB successfully");

                        // const screenSize = await GetScreenSize(fetchDevice);
                        // console.log(screenSize);
                        // setWidth(screenSize.width);
                        // setHeight(screenSize.height);
                        const screenSize = await axios({
                            url: `https://${fetchDevice.data.device.domainName}:${fetchDevice.data.device.port}/api/screensize`,
                            method: "GET"
                        });

                        if(screenSize.status === 200) {
                            setTimeout(() => {
                                console.log(screenSize);
                                if(screenSize.data.width >= 1920 && screenSize.data.height >= 1080) {
                                    setWidth(screenSize.data.width/1.5);
                                    setHeight(screenSize.data.height/1.5);
                                } else {
                                    setWidth(screenSize.data.width);
                                    setHeight(screenSize.data.height);
                                }
                            }, 2000);
                        }
                    }, 2000);
                } else {
                    setTimeout(() => {
                        console.log("Failed to grab device data from DB");
                        setData({hostname: "Something went wrong when connecting to your device"});
                    }, 5000);
                    location.href('/dashboard');
                }
            } catch (err) {
                console.log(err);
            }
        }
        grabDevice();

        // Prevents scrolling down when the spacebar is pressed
        // document.querySelector('article').onkeydown = function(e) {
        //     return e.keyCode !== 32;
        // };
    },[]);

    return(
        <article className='flex row margin-t-xxl'>
            <section className="flex column justify-content-start">
                {url ? 
                    <>
                        <RemoteSideBar props={data}/>
                        <OutputBox />
                    </>
                    :
                    <div></div>
                }
            </section>
            
            <div className="flex column align-items-cntr">
                {/* <div className="spacer"></div> */}
                {data ?
                    <span className="h2">{data.hostname}</span>
                    :
                    <>
                        <span className="h1">Loading Computer</span>
                        <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                    </>
                }
                <iframe src={url} width={width+40} height={height+50}></iframe>
            </div>
        </article>
    );
}

export default RemoteCtrlPage;